export const WGSL_LAYOUT = {
  Node: { align: 4, size: 16 },
  VCbCrPos: { align: 4, size: 32 },
  HalfMoonColors: { align: 4, size: 64 },
  SpinDebug: { align: 8, size: 24 },
  CircleColorEvidence: { align: 4, size: 88 },
  GridInfo: { align: 8, size: 56 },
  Blob2Basic: { align: 4, size: 16 },
  DetectedCircleInfoGPU: { align: 4, size: 32 },
  Blob2: { align: 8, size: 288, strideWords: 72 },
  StickerInfoGpu: { align: 8, size: 472, strideWords: 118 },
} as const;

export const BLOB2_OFFSETS = {
  alive: 0,
  x: 4,
  y: 8,
  width: 12,
  height: 16,
  nn_0: 20,
  nn_dist_1: 24,
  nn_1: 28,
  nn_dist_0: 32,
  nn_2: 36,
  nn_dist_2: 40,
  sticker_count: 44,
  pad0: 48,
  color_pair: 52,
  ndir: 120,
  orientation_confidence: 128,
  circle_type: 132,
  color_index: 136,
  blue_perc: 140,
  green_perc: 144,
  red_perc: 148,
  black_perc: 152,
  fail_code: 156,
  pad1: 160,
  pad2: 164,
  spin_debug: 168,
  evidence: 192,
} as const;